import { Centred, Contents } from '../../styles/mixins'
import { RichText } from '../../styles/mixins'


const styles = theme => {
  return {
    contents: {
      ...Contents(theme)
    },
    section: {
      background: 'rgba(255,255,255,1)',
      //padding: '3rem 3rem',
      maxWidth: 1024,
      [theme.breakpoints.down('sm')]: {
        padding: '2rem 2rem',
      },
    },
    contentWrap: {
      position: 'relative',
      display: 'flex',

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        padding: '0'
      }
    },
    contentLink: {
      display: 'flex',
      flexDirection: 'column',

      flex: '0 0 50%',
      ['& a']: {
        flex: '0 0 50%',
        height: '400px',
      },
      ['&:last-child']: {
        transform: 'translate(-5%, 0)',
        textAlign: 'right',
        ['& $contentMeta']: {
          order: 0,
          paddingBottom: '1rem',
          paddingLeft: '3rem',
          paddingRight: 0,
          [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
          }
        }
      },
      ['&:hover']: {
        transform: 'translate(0, -5px)',
        transition: 'transform 0.2s ease-in'
      },
      ['&:last-child:hover']: {
        transform: 'translate(-5%, -5px)'
      },
      [theme.breakpoints.down('sm')]: {
        flex: '0 0 100%',
        marginBottom: '5rem',
        ['& a']: {
          height: '400px'
        },
        ['&:hover']: {
          transform: 'none'
        },
        ['&:last-child:hover']: {
          transform: 'none'
        },
        ['&:last-child']: {
          transform: 'none',
          textAlign: 'initial',
          marginBottom: '0'
        }
      },
      [theme.breakpoints.down('xs')]: {
        ['& a']: {
          height: '200px'
        }
      },
    },
    contentImage: {
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: theme.palette.softer,
      boxShadow: theme.shadows[3],

      [theme.breakpoints.down('sm')]: {
        height: '16rem',
      },
      [theme.breakpoints.down('xs')]: {
        height: '16rem',
      },
      [theme.breakpoints.down('lg')]: {
        height: '16rem',
      },
      height:'26rem',

      width: '100%',
      flexGrow: '1'
    },
    contentMeta: {
      paddingBottom: '0',
      paddingTop: '1rem',
      paddingLeft: 0,
      paddingRight: '3rem',
      order: 1,
      [theme.breakpoints.down('sm')]: {
        paddingBottom: '1rem',
        paddingTop: '0',
        order: 0
      },
      ['& a']: {
        textDecoration: 'none'
      }
    },
    contentMetaTitle: {
      ...theme.typography.title,
      lineHeight: '1',
      marginBottom: '0.5rem',
    },
    contentMetaType: {
      ...theme.typography.caption,
      textTransform: 'uppercase',
      fontWeight: theme.typography.fontWeightMedium
    }
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/relatedcontent/styles.js